import { keyframes } from "styled-components"

export const dealInAnim = keyframes`
    0% {
      transform: translate(320px, -500px) rotate(-180deg);
    }
    100% {
      transform: translate(0, 0) rotate(0);
    }
`
export const playerDealOutAnim = keyframes`
    0% {
      transform: translate(0, 0) rotate(0deg);
      animation-timing-function: cubic-bezier(0.08, 0, 0, 1);
    }
    100% {
      transform: translate(-200px, 0) rotate(0deg);
    }
`
export const bankerDealOutAnim = keyframes`
    0% {
      transform: translate(0, 0) rotate(0deg);
      animation-timing-function: cubic-bezier(0.08, 0, 0, 1);
    }
    100% {
      transform: translate(200px, 0) rotate(0deg);
    }
`

export const scaleAnim = keyframes`
    0% {
      transform: scale(1);
      animation-timing-function: cubic-bezier(0.74, 0, 0.29, 1);
    }
    47% {
      transform: scale(1.1);
      background: #b3cf85;
    }
    100% {
      transform: scale(1);
    }
`
